import React, {useEffect} from 'react';
import {withRouter, RouteComponentProps} from 'react-router-dom';
import {Type} from '@spotify-internal/encore-web';

import withTranslation from 'lib/shared/i18n/withTranslation';
import analytics from 'lib/client/analytics/analytics';
import ErrorMessage from 'components/ErrorMessage/ErrorMessage';
import {TranslationProps} from 'etc/types';

interface NotFoundMessageProps extends RouteComponentProps, TranslationProps {}

const NotFoundMessage = ({t, location}: NotFoundMessageProps) => {
  useEffect(() => {
    // If we load the NotFoundMessage, it is basically a clientside 404. Send a custom pageview.
    analytics.trackPageView(`/404/?url=${encodeURI(location.pathname + location.search)}`);
  }, [location]);

  return (
    <div className="container">
      <ErrorMessage title={t('subtitle_400')}>
        <Type.p variant="body1">{t('message_400')}</Type.p>
      </ErrorMessage>
    </div>
  );
};

export default withTranslation()(withRouter(NotFoundMessage));
